import styles from './index.module.scss';
import type { GroupSettingButtonProps } from './interface';

export const GroupSettingButton = ({
  icon,
  onClick,
  disabled,
  children,
  type,
  style,
}: GroupSettingButtonProps) => {
  return (
    <div
      className={cls(styles.groupSettingButton, 'groupSettingButton', {
        [styles.disabled]: disabled,
        [styles.danger]: type === 'danger',
        [styles.text]: type === 'text',
      })}
      style={style}
      onClick={onClick}
    >
      <div className={styles.groupSettingButtonIcon}>{icon}</div>
      <div className={styles.groupSettingButtonText}>{children}</div>
    </div>
  );
};
